module.exports = __webpack_public_path__ + "img/close-btn.e4464040.svg";